import { gql } from 'apollo-boost';

export const paged = gql`
  query orgRef_GlCode(
    $orgId: ID!
    $limit: Int!
    $offset: Int!
    $includeExpired: Boolean!
  ) {
    orgRef_GlCode {
      paged(
        orgId: $orgId
        limit: $limit
        offset: $offset
        includeExpired: $includeExpired
      ) {
        results {
          id
          externalId
          name
          description
          active
          rowVersion
        }
        totalCount
      }
    }
  }
`;

export const allCodesNameID = gql`
  query orgRef_GlCode($orgId: ID!, $includeExpired: Boolean!) {
    orgRef_GlCode {
      all(orgId: $orgId, includeExpired: $includeExpired) {
        externalId
        name
      }
    }
  }
`;
